<template lang="pug">
el-card(shadow="hover").pvtnCard
  div.cardHeader
    b {{ pvtnRequest.municipio.nome }}
    el-button(
      size="small",
      type="primary"
      @click="aplicarValores"
      :disabled="isVisualizar"
    ) Aplicar valores em todos
  div#line
  el-row.center
    el-col.flex(:span="10")
      span VTN/ha mínimo:
      app-double-input.input(
        prefix='R$ ',
        v-model="pvtnRequest.vtnPorHaMin",
        :disable="isVisualizar"
      )
    el-col.flex(:span="10")
      span VTN/ha médio:
      app-double-input.input(
        prefix='R$ '
        v-model="pvtnRequest.vtnPorHaMed"
        :disable="isVisualizar"
      )
    el-col.flex(:span="10")
      span VTN/ha máximo:
      app-double-input.input(
        prefix='R$ '
        v-model="pvtnRequest.vtnPorHaMax"
        :disable="isVisualizar"
      )
</template>

<script>
import AppDivider from '@/components/AppDivider'
import AppDoubleInput from '@/components/AppDoubleInput'

export default {

  components: {
    AppDivider,
    AppDoubleInput
  },

  props: {
    pvtnRequest: {
      type: Object,
      required: true
    },
    isVisualizar: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  methods: {
    aplicarValores () {
      this.$emit('aplicarValores', this.pvtnRequest)
    }
  }
}
</script>

<style lang="scss" scoped>
.pvtnCard {
  box-shadow: 0px 3px 6px #00000029;
}

.flex {
  display: flex;
}

.center {
  display: flex;
  gap: 2%;
}

#line {
  width: 100%;
  background-color: gainsboro;
  height: 2px;
  margin-top: 11px;
  margin-bottom: 25px;
}

.cardHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/vtn/components/PvtnMunicipioCard.vue